import Icon from 'react-icon-base';

const IcDocument = props => (
   <Icon viewBox='0 0 108.24 108.24' {...props}>
      <g id='Mode_Isolation' data-name='Mode Isolation'>
         <g fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='3px'>
            <g>
               <line class='cls-1' x1='47.86' y1='41.97' x2='71.08' y2='41.97' />
               <line class='cls-1' x1='47.86' y1='49.96' x2='71.08' y2='49.96' />
               <line class='cls-1' x1='47.86' y1='57.94' x2='71.08' y2='57.94' />
               <line class='cls-1' x1='47.86' y1='66.03' x2='60.66' y2='66.03' />
               <path
                  class='cls-1'
                  d='M68.41,86.17h-28.45c-1.76,0-3.2-1.43-3.2-3.2v-49.1c0-1.76,1.43-3.2,3.2-3.2h39.02c1.76,0,3.2,1.43,3.2,3.2v39.79l-13.77,12.51Z'
               />
               <path class='cls-1' d='M71.65,73.66c-1.76,0-3.2,1.43-3.2,3.2v9.31l13.72-12.51h-10.53Z' />
               <path
                  class='cls-1'
                  d='M36.77,33.87c0-1.76,1.43-3.2,3.2-3.2h33.27v-5.75c0-1.76-1.43-3.2-3.2-3.2H31.01c-1.76,0-3.2,1.43-3.2,3.2v49.1c0,1.76,1.43,3.2,3.2,3.2h5.75v-43.35Z'
               />
            </g>
            <circle class='cls-1' cx='54.12' cy='54.12' r='52.62' />
         </g>
      </g>
   </Icon>
);
export default IcDocument;
